import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core'
import { MatTableDataSource, MatTableModule } from '@angular/material/table'
import { JsonPipe, NgClass, NgIf } from '@angular/common'
import { CnpjPipe } from '../../pipes/cpnj.pipes'
import { CpfPipe } from '../../pipes/cpf.pipes'
import { TelefonePipe } from '../../pipes/phone.pipes'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltip } from '@angular/material/tooltip'

@Component({
  selector: 'table-list-select-purchases-new',
  imports: [
    MatTableModule,
    MatIconModule,
    NgIf,
    CnpjPipe,
    CpfPipe,
    TelefonePipe,
    NgClass,
    MatTooltip,
    JsonPipe,
  ],
  templateUrl: './table-list-select-purchases-new.component.html',
  styleUrl: './table-list-select-purchases-new.component.scss',
})
export class TableListSelectPurchasesNewComponent implements OnInit, OnChanges {
  constructor() {}

  @Input() dataSource: any[] = []
  @Input() columns: any[] = []
  @Output() selectItem = new EventEmitter<any>()
  @Output() deleteItem = new EventEmitter<any>()
  @Output() managerItem = new EventEmitter<any>()
  @Output() itinerariesItem = new EventEmitter<any>()
  @Input() listSelected: any[] = []
  @Input() selected: any = {}
  @Input() multiSelect: boolean = false

  displayedColumns: string[] = []
  tableSource: MatTableDataSource<any> = new MatTableDataSource()

  ngOnInit() {
    if (this.dataSource.length > 0) {
      this.displayedColumns = this.columns.map((obj: any) => obj.keyColumn)
      this.tableSource = new MatTableDataSource<any>(this.dataSource)
      this.updateTableDataSource()
    }
  }

  ngOnChanges() {
    this.updateTableDataSource()
  }

  private updateTableDataSource() {
    this.tableSource.data = this.dataSource
  }

  selectItemEvent(item: any): void {
    console.log('item: ', item)
    if (item.statusId == 1 || item.statusId == 3) {
      console.log('item: ', item)
      this.selectItem.emit(item)
    }
  }

  deleteItemEvent(item: any): void {
    this.deleteItem.emit(item)
  }

  itinerariesItemEvent(item: any): void {
    this.itinerariesItem.emit(item)
  }

  checkSelect(element: any) {
    if (element.statusId == 2 || element.statusId == 4) {
      return 'row-disabled'
    } else if (element.id && element) {
      if (this.multiSelect) {
        let index = this.listSelected.findIndex((item) => item.id == element.id)
        return index == -1 ? '' : 'row-selected'
        // return index == -1 ? false : true
      } else {
        return element.id == this.selected.id ? 'row-selected' : ''
        // return element.id == this.selected.id
      }
    } else {
      return ''
    }
  }

  checkSelectBKP(element: any) {
    // if (element.statusId != 1 && element.statusId != 3) {
    //   return true
    // }
    if (element.id && element) {
      if (this.multiSelect) {
        let index = this.listSelected.findIndex((item) => item.id == element.id)
        return index == -1 ? false : true
      } else {
        return element.id == this.selected.id
      }
    }
    return false
  }

  managerItemEvent(item: any): void {
    this.managerItem.emit(item)
  }
}
